const LARGE_VALUE_LENGTH = 100000;

export const cleanupInspectionStorage = ({ removeAllDrafts = false } = {}) => {
  const keysToRemove = [];

  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!key) {
      continue;
    }

    const isInspectionDraft = key.startsWith('inspection_') || key === 'inspectionSessionId' || key === 'inspectionId';
    if (!isInspectionDraft) {
      continue;
    }

    const isLargeInspectionValue = key.includes('_pictures') || key.includes('_damage') || (localStorage.getItem(key) || '').length > LARGE_VALUE_LENGTH;
    if (removeAllDrafts || isLargeInspectionValue) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
};

export const safeSetInspectionItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    if (error.name !== 'QuotaExceededError') {
      throw error;
    }

    cleanupInspectionStorage();

    try {
      localStorage.setItem(key, value);
      return true;
    } catch (retryError) {
      if (retryError.name !== 'QuotaExceededError') {
        throw retryError;
      }
      return false;
    }
  }
};
